/* istanbul ignore file */
export * from './SearchResultPageZeroResults';
